import { Route, useLocation, Routes } from 'react-router-dom';
import { lazy, Suspense, useEffect, useState } from 'react';
import LoadingPage from './components/global/LoadingPage';

import NavBar from './components/NavBars';
import Footer from './components/Footer/footers/Footer';
import ScrollToTopButton from './components/global/ScrollToTopButton';
import { useBasicData } from './hooks/useBasicData';
// import { Helmet } from 'react-helmet-async';
import NotFound from './pages/NotFound';
// import CardItems from './pages/CardItems';
import PreLoader from './components/global/PreLoader';
import PrivacyPolicy from './pages/PrivacyPolicy';
// import DownloadBrochure from './components/global/DownloadBrochure';
// import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button, Typography, Box } from '@mui/material';
// import WhatsAppIcon from '@mui/icons-material/WhatsApp';
// import { useTranslation } from 'react-i18next';
// import i18next from 'i18next';
// Pages

const Home = lazy(() => import("./pages/Home"));
const AboutUs = lazy(() => import("./pages/About"));
const Events = lazy(() => import("./pages/Events"));
const Certificate = lazy(() => import("./pages/Certificate"));
const Event = lazy(() => import("./pages/Event"));
const Products = lazy(() => import("./pages/Products"));
const Product = lazy(() => import("./pages/Product"));
const OurBlogs = lazy(() => import("./pages/OurBlogs"));
const Blog = lazy(() => import("./pages/Blog"));
const ContactUs = lazy(() => import("./pages/ContactUs"));

const RoutesPath = () => {
    const { basicData } = useBasicData()
    const [isFirstLoad, setIsFirstLoad] = useState(true);
    // const { t } = useTranslation();
    useEffect(() => {
        if (isFirstLoad) {
            setTimeout(() => setIsFirstLoad(false), 3000); // بعد 2 ثانية أخفِ الـ PreLoader
        }
    }, [isFirstLoad]);

    const ScrollToTop = () => {
        const { pathname } = useLocation();
        useEffect(() => {
            window.scrollTo(0, 0);
        }, [pathname]);
        return null;
    };
    // const [openModal, setOpenModal] = useState(false);

    // useEffect(() => {
    //     const timer = setTimeout(() => {
    //         setOpenModal(true);
    //     }, 10000);
    //     return () => clearTimeout(timer);
    // }, []);
    // const lng = i18next.language
    // const handleClose = () => {
    //     setOpenModal(false);
    // };
    return (
        <>
            {isFirstLoad ? (
                <PreLoader onFinish={() => setIsFirstLoad(false)} />
            ) : (
                <>
                    <NavBar />
                    <ScrollToTop />
                    <ScrollToTopButton whatsApp={basicData?.data?.whatsappNumber} phone={basicData?.data?.tel1} />
                    <Suspense fallback={<LoadingPage />}>
                        <Routes>
                            <Route path="/" element={<Home />} />
                            <Route path="/about" element={<AboutUs />} />
                            <Route path="/products" element={<Products />} />
                            <Route path="/product/:productSlug" element={<Product />} />
                            <Route path="/events" element={<Events />} />
                            <Route path="/event/:eventSlug" element={<Event />} />
                            <Route path="/certificate" element={<Certificate />} />
                            <Route path="/blogs" element={<OurBlogs />} />
                            <Route path="/blogs/:blogSlug" element={<Blog />} />
                            <Route path="/contact" element={<ContactUs />} />
                            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                            <Route path="*" element={<NotFound />} />
                        </Routes>
                    </Suspense>
                    <Footer basicData={basicData} />
                </>
            )}
        </>
    );
};

export default RoutesPath;
